<template>
  <div>
    <div class="header">
      <div class="header-container" v-if="isLogin">
        <img :src="imgLogin" class="header-img" />
        <p class="header-text" @click="toLogin">用户ID：{{ username }}</p>
      </div>
      <div class="header-container" v-else>
        <img src="../assets/img/logintitle.jpg" class="header-img" />
        <p class="header-text" @click="toLogin">点击登陆</p>
      </div>
    </div>
    <van-cell
      title="客服中心"
      icon="service-o"
      size="large"
      is-link
      @click="tokeFu"
    />

    <van-cell
      title="三人成行，享检测九折优惠"
      icon="friends-o"
      size="large"
      is-link
      @click="$router.push('/team')"
      v-if="isLogin"
    />

    <van-cell
      title="退出登录"
      icon="info-o"
      size="large"
      is-link
      @click="tologOut"
      v-if="isLogin"
    />
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      show: false,
      isLogin: false,
      username: "",
      imgLogin: require("../assets/img/logintitle.jpg"),
      wxdev: false,
      ordernum: "",
    };
  },
  created() {
    let token = window.sessionStorage.getItem("Token");
    const ua = window.navigator.userAgent.toLowerCase();
    this.wxdev = ua.match(/MicroMessenger/i) == "micromessenger";
    this.username = window.sessionStorage.getItem("user_id") || window.sessionStorage.getItem("username");
    this.imgLogin = window.sessionStorage.getItem("avatar") || this.imgLogin;

    if (token) {
      this.isLogin = true;
    }
  },
  methods: {
    toLogin() {
      if (this.wxdev) {
        this.$router.push({
          path: "/blankpage",
          query: {
            currentpath: "/service",
          },
        });
      } else {
        this.$router.push("/login");
      }
    },

    tokeFu() {
      window.location.href =
        "https://chatbot.weixin.qq.com/webapp/Ws75Px9atGV9s4UkR64nosl5FI8L7b?isFloat=false&robotName=%E4%B8%87%E6%96%B9%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D";
    },
    // toAbout() {
    //   this.$router.push("/about");
    // },
    tologOut() {
      Dialog.confirm({
        title: "标题",
        message: "确定要退出吗",
      }).then(() => {
        window.sessionStorage.clear();
        this.isLogin = false;
        window.location.href = `/p`;
      });
    },
  },
};
</script>

<style scoped>
.header {
  height: 3.3rem;
  width: 100%;
  background-color: #228ef7;
}
.header-img {
  border-radius: 50%;
  width: 1.7rem;
  height: 1.7rem;
  position: absolute;
  top: 50%;
  margin-top: 0.8rem;
  left: 5%;
}
.header-container {
  position: relative;
}
.header-text {
  position: absolute;
  top: 50%;
  margin-top: 1.4rem;
  margin-left: 2.6rem;
  color: #fff;
  font-weight: 10px;
  font-size: 0.4rem;
}
</style>
